"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading3 = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const H3 = styled_components_1.default.span `
	display: block;
	color: inherit;
	text-transform: none;

	/* make sure to override account-management */
	&.h3 {
		margin: 0;
		font-size: 20px;
		font-family: ${(p) => p.theme.fonts.heading3 || p.theme.fonts.default};
		font-weight: 400;
		line-height: 28px;
	}
`;
const Heading3 = ({ children }) => {
    return react_1.default.createElement(H3, { className: "h3" }, children);
};
exports.Heading3 = Heading3;
//# sourceMappingURL=Heading3.atom.js.map